import Vue from "vue";
// import axios from "axios"
import RestClient from "@/app/shared/services/restClient";
import userContextService from "../services/userContextService";
import { apiUrls } from "@/environment/environment";
import authHelper from "@/app/shared/services/authHelper";
import urlApiHelper from "@/app/shared/services/urlApiHelper";

const userContext = {
  namespaced: true,
  state: {
    companies: null,
    currentCompany: null,
    warehouses: [],
    currentWarehouse: null,
    rights: [],
    code: null,
    name: null,
    surname: null,
    initials: null,
    authToken: null
  },
  getters: {
    isAuthenticated: state => {
      return state.authToken != null;
    },
    getToken: state => {
      return state.authToken;
    },
    isAuthorized: state => {
      return state.rights.length > 0;
    }
  },
  mutations: {
    clearState(state) {
      state.companies = null;
      state.currentCompany = null;
      state.warehouses = [];
      state.currentWarehouse = null;
      state.rights = [];
      state.code = null;
      state.name = null;
      state.surname = null;
      state.initials = null;
      state.authToken = null;
    },
    currentCompany(state, newState) {
      state.currentCompany = newState;
      sessionStorage.setItem("currentCompany", newState);
      if (localStorage.getItem("defaultCurrentCompany") == null) {
        localStorage.setItem("defaultCurrentCompany", newState);
      }
    },
    companies(state, newState) {
      state.companies = newState;
    },
    currentWarehouse(state, newState) {
      state.currentWarehouse = newState;
      sessionStorage.setItem("currentWarehouse", newState);
      if (localStorage.getItem("defaultCurrentWarehouse") == null) {
        localStorage.setItem("defaultCurrentWarehouse", newState);
      }
    },
    warehouses(state, newState) {
      state.warehouses = newState;
    },
    rights(state, newState) {
      state.rights = newState;
    },
    code(state, newState) {
      state.code = newState;
    },
    name(state, newState) {
      state.name = newState;
    },
    surname(state, newState) {
      state.surname = newState;
    },
    initials(state, newState) {
      state.initials = newState;
    },
    authToken(state, newState) {
      state.authToken = newState;
    }
  },
  actions: {
    updateCurrentCompany({ commit, state }, newCompany) {
      return new Promise((resolve, reject) => {
        //Apple a l'api user
        let userAPI = apiUrls.user;
        this.client = new RestClient(userAPI);
        this.restClient = new RestClient(userAPI).Instance;
        this.restClient
          .post("/Users/CurrentCompany?currentCompanyCode=" + newCompany)
          .then(response => {
            if (response.status == 204) {
              //TODO a revoir (suppression de Keycloak)
              commit("currentCompany", "");
              userContextService.refreshUserWarehouses();
              resolve(state.currentCompany);
            } else {
              reject(response.statusText);
            }
          })
          .catch(error => {
            Vue.$log.error(error);
            reject("Error updateCurrentCompany from User API: " + error);
          });
      });
    },
    updateCurrentWarehouse({ commit, state }, newWarehouse) {
      return new Promise((resolve, reject) => {
        //Apple a l'api us
        let userAPI = apiUrls.user;
        this.client = new RestClient(userAPI);
        this.restClient = new RestClient(userAPI).Instance;
        this.restClient
          .post("/Users/CurrentWarehouse?currentWarehouseCode=" + newWarehouse)
          .then(response => {
            if (response.status == 204) {
              //TODO a revoir (suppression de Keycloak)
              commit("currentWarehouse", "");
              resolve(state.currentWarehouse);
            } else {
              reject(response.statusText);
            }
          })
          .catch(error => {
            Vue.$log.error(error);
            reject("Error updateCurrentWarehouse from User API: " + error);
          });
      });
    },

    updateCurrentCompanyWarehouse({ commit, state }, payload) {
      return new Promise(resolve => {
        //Apple a l'api us
        let userAPI = apiUrls.user;
        this.client = new RestClient(userAPI);
        this.restClient = new RestClient(userAPI).Instance;

        commit("currentCompany", payload.companyCode);
        commit("currentWarehouse", payload.warehouseCode);
        userContextService.setUserRightsFromApi().then(resolve(state));
      });
    },

    updateRights({ commit, state }, newRights) {
      return new Promise((resolve, reject) => {
        if (Array.isArray(newRights)) {
          commit("rights", newRights);
          resolve(state.rights);
        } else {
          reject("Object must be an Array.");
        }
      });
    },
    updateWarehouses({ commit, state }, newWarehouses) {
      return new Promise((resolve, reject) => {
        if (Array.isArray(newWarehouses)) {
          commit("warehouses", newWarehouses);
          resolve(state.warehouses);
        } else {
          reject("Object must be an Array.");
        }
      });
    },

    logout({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          sessionStorage.clear();
          localStorage.clear();
          Vue.$cookies.remove("authToken");
          commit("clearState");
          resolve();
        } catch (error) {
          //Log
          Vue.$log.error(error);
          reject("Error logout from tesfriconfigurationAPI : " + error);
        }
      });
    },

    // eslint-disable-next-line no-unused-vars
    async login({ state }, userinfo) {
      await urlApiHelper.setUrlAuthFromApi(userinfo);

      await authHelper.getAuthTokenFromApi(userinfo);

      await userContextService.setUserRightsFromApi();

      await userContextService.setUserInfosFromApi();

      await userContextService.refreshUserWarehouses();
    },

    /**
     * Auto login with key
     */
    // eslint-disable-next-line no-unused-vars
    async autoLogin({ state, commit }, queryInfo) {
      await urlApiHelper.setUrlAuthFromApi(queryInfo);

      await authHelper.getAuthTokenFromApiWithKey(queryInfo);

      await userContextService.setUserRightsFromApi();

      await userContextService.setUserInfosFromApi();

      await userContextService.refreshUserWarehouses();
    },

    async initContextStateWithCookies({ commit }) {
      let authTokenCookies = Vue.$cookies.get("authToken");
      commit("authToken", authTokenCookies);
      let currentCompany = null;
      // Si on ouvre un nouvel onglet/fenetre le sessionStorage est vide donc on prends dans le localstorage
      if (sessionStorage.getItem("currentCompany")) {
        currentCompany = sessionStorage.getItem("currentCompany");
      } else {
        currentCompany = localStorage.getItem("defaultCurrentCompany");
      }
      commit("currentCompany", currentCompany);

      // Si on ouvre un nouvel onglet/fenetre le sessionStorage est vide donc on prends dans le localstorage
      let currentWarehouse = null;
      if (sessionStorage.getItem("currentWarehouse")) {
        currentWarehouse = sessionStorage.getItem("currentWarehouse");
      } else {
        currentWarehouse = localStorage.getItem("defaultCurrentWarehouse");
      }
      commit("currentWarehouse", currentWarehouse);

      await userContextService.setUserRightsFromApi();

      await userContextService.setUserInfosFromApi();

      await userContextService.refreshUserWarehouses();
    }
  }
};

export default userContext;
